"use client";
import React, { FC, Fragment } from "react";
import { useMutation } from "@apollo/client/react";
import { faTrashAlt, faTrophy } from "@fortawesome/pro-solid-svg-icons";
import { useRouter } from "next/navigation";

import { Button } from "@/components";
import { ThreadType } from "@/gql/generated/graphql";
import { MUTATE_CLOSE_COMPETITION } from "@/gql/queries/mutate-close-competition";
import { MUTATE_DELETE_THREAD } from "@/gql/queries/mutate-delete-thread";

type ThreadAdminControlsProps = {
  threadId: number;
  threadType: ThreadType;
};

const ThreadAdminControls: FC<ThreadAdminControlsProps> = ({
  threadId,
  threadType,
}) => {
  const router = useRouter();

  const [deleteThread] = useMutation(MUTATE_DELETE_THREAD, {
    onCompleted: () => {
      router.push("/community");
    },
  });

  const [closeCompetition] = useMutation(MUTATE_CLOSE_COMPETITION);

  const onDeleteThreadPressed = () => {
    if (!window.confirm("Delete this thread?")) return;
    deleteThread({ variables: { id: threadId } });
  };

  const onCloseCompetitionPressed = () => {
    closeCompetition({ variables: { threadId: threadId } });
  };

  return (
    <Fragment>
      {threadType === ThreadType.Competition && (
        <Button
          icon={faTrophy}
          type="neutral"
          onClick={onCloseCompetitionPressed}
        >
          Close competition
        </Button>
      )}
      <Button
        icon={faTrashAlt}
        type="negative"
        onClick={onDeleteThreadPressed}
      >
        Delete thread
      </Button>
    </Fragment>
  );
};

export default ThreadAdminControls;
